import { LightningElement } from "lwc";

export default class GlobalActions extends LightningElement {}
